export interface ScanItem {
  code: string;
  scanned: boolean;
}
